import React, { useState, useContext } from "react";
import { object, arrayOf } from "prop-types";
import FilterDropdown from "../FilterDropdown/FilterDropdown.jsx";
import Tooltip from "../Tooltip/Tooltip.jsx";
import { QueryStringContext } from "../../QueryStringContext/QueryStringContext.jsx";
import { toggleFacet } from "../../../../common/helpers.js";
import * as R from "ramda";

const propTypes = {
  facets: arrayOf(object).isRequired,
};

const FilterBar = ({ facets }) => {
  const { queryStringState, setQueryStringState, model } = useContext(QueryStringContext);

  const { dictionary } = model;

  const StyleClearFacet = (queryStringState.f && queryStringState.f.length >= 1) ? 'filter-bar-clear' : 'filter-bar-clear-hide';
  // console.log("FilterBar Facets: ", facets);
  // console.log("Query String State: ", queryStringState);

  if (!facets || facets.length < 1) {
    return null;
  }
  return (
    <section className="filter-bar">
      <a href="?page=0#sfp-search" className={StyleClearFacet}>Clear Filters</a>
      <div id="FILTER-MENU" className="filter-bar__menu">
        {dictionary.filterTitle && (
          <h2 className="filter-bar__title" id="filter-bar-title">
            <span>{dictionary.filterTitle}</span>
            {dictionary.tooltipText && (
              <Tooltip
                label={dictionary.tooltipLabel}
                text={dictionary.tooltipText}
              />
            )}
          </h2>
        )}
       <div className="filter-bar__filter-menus">
          {facets &&
            facets.map((facet, i) => {
              // console.log("rendering FilterDropdown for facet ", facet);
              return (
                <FilterDropdown
                  key={JSON.stringify(`${facet.url_alias}`)}
                  {...facet}
                  dropdownLabel={dictionary.filterBy}
                  allowMultiple={false}
                  param="f"
                  values={facet.values}
                  type={facet.url_alias}
                  id={facet.url_alias}
                  selectedFacets={queryStringState}
                  onFacetChange={(id, value) => {
                    setQueryStringState({
                      ...toggleFacet(
                        id,
                        `${facet.url_alias}:${R.unnest([value])}`,
                        queryStringState,
                      ),
                      page: 0,
                    });
                  }}
                />
              );
            })}
          <a href="?page=0#sfp-search" className={StyleClearFacet}>Clear Filters</a>
        </div>
      </div>
    </section>
  );
};

FilterBar.propTypes = propTypes;
export default React.memo(FilterBar);
